<template>
	<div id="app" class="app">
		<router-view v-if="isRouterAlive"></router-view>
		<Dialog v-if="openDialog" />
	</div>
</template>
<script>
	import Dialog from '@/plugins/Dialog.vue';
	import {
		isHttps,
		isMobile,
		isWeiXin,
		sourceUrl
	} from '@/utils/toolSet';
	import {
		wxShare
	} from '@/utils/wxShare';
	export default {
		name: 'App',
		components: {
			Dialog
		},
		provide() {
			return {
				reload: this.reload
			};
		},
		data() {
			return {
				isActive: false,
				isRouterAlive: true,
				option: {
					title: '2023快手村BA·贵州站',
					desc: '直播时间：2023年6月2日-11日',
					link: 'https://h5.eventnet.cn/kuaishouPlayBA/',
					logo: 'https://oss.eventnet.cn/H5/kwaiPlay/img1/share.jpg'
				},
				count: 0,
				openDialog: false
			};
		},
		mounted() {
			const THAT = this;
			/** 微信分享条件：线上|手机端|微信下 */
			if (isHttps() && isMobile() && isWeiXin()) {
				wxShare(THAT.option);
			}
		},
		created() {
			/** 电脑打开&&非PC.html页面 */
			if (!isMobile() && sourceUrl('device').indexOf('PC') == -1) {
				window.location.href = './PC.html';
			}
		},
		methods: {
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(() => {
					this.isRouterAlive = true;
				});
			}
		}
	};
</script>
<style lang="less">
	.app {
		font-family: 'Microsoft YaHei', 'Arial', Helvetica, sans-serif;
		font-size: 30px;
		line-height: 1.5;
		text-align: left;
		color: #fff;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	.van-swipe__indicators {
		bottom: 15px !important;
	}

	.van-swipe__indicator {
		transition: all 0.5s;
	}

	.van-swipe__indicator {
		background-color: #7c7c7c;
		opacity: 1;
	}

	.van-swipe__indicator--active {
		width: 12px !important;
		height: 12px !important;
		border-radius: 12px;
		background-color: #fff;
	}
</style>